"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LoadingView = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _jsxRuntime = require("react/jsx-runtime");

var GoldenCenter = _styledComponents["default"].div.withConfig({
  displayName: "GoldenCenter",
  componentId: "sc-12pja4t-0"
})(["display:flex;align-items:center;justify-content:center;height:calc(100vh * (1 / ", "));"], function (_ref) {
  var theme = _ref.theme;
  return (0, _lodash["default"])(theme, 'goldenRatio');
});

var LoadingContent = _styledComponents["default"].div.withConfig({
  displayName: "LoadingContent",
  componentId: "sc-12pja4t-1"
})(["display:flex;flex-flow:column nowrap;align-items:center;& > ", "{color:", ";margin:24px 0;}"], _baseReactComponents.LoadingDots, function (_ref2) {
  var theme = _ref2.theme;
  return (0, _lodash["default"])(theme, 'azure');
});

var LoadingView = function LoadingView(_ref3) {
  var className = _ref3.className,
      _ref3$message = _ref3.message,
      message = _ref3$message === void 0 ? null : _ref3$message,
      _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? null : _ref3$children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(GoldenCenter, {
    className: className,
    "data-testid": "loading-view",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(LoadingContent, {
      children: [message, /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.LoadingDots, {}), children]
    })
  });
};

exports.LoadingView = LoadingView;
LoadingView.displayName = 'LoadingView';

var _default = (0, _styledComponents["default"])(LoadingView).withConfig({
  componentId: "sc-12pja4t-2"
})([""]);

exports["default"] = _default;
//# sourceMappingURL=index.js.map